<template>
    <div :class="container_class">
        <label class="vs-input--label">{{ label }}</label>
        <v-select 
            v-model="value"
            :options="options"
            :placeholder="placeholder"
            :class="input_class"
            :disabled="disabled"
        />
        <small class="text-danger d-block" v-if="warning">{{ warning_text }}</small>
    </div>
</template>
<script>
import vSelect from 'vue-select'

export default {
    props: {
        label: {
            default: null
        },
        options: {
            default: ()=>[]
        },
        warning: {
            default: false
        },
        warning_text: {
            default: null
        },
        input_class: {
            default: ''
        },
        placeholder: {
            default: null
        },
        model: {
            default: null
        },
        disabled: {
            default: false
        },
        container_class: {
            default: 'w-full'
        },
        clear_if_not_found: {
            default: false
        }
    },
    components: {
        'v-select': vSelect
    },
    data() {
        return {
            value: null
        }
    },
    mounted() {
        this.setActualValue(this.model)
    },
    watch: {
        model(value) {
            this.setActualValue(value)
        },
        value(newV, oldV){
            if(newV == oldV) return

            let value = newV ? newV.value : null

            this.$emit('update:model', value)
            this.$emit('change', value)
        },
        options(newV, oldV) {
            this.setActualValue()
        }
    },
    methods: {
        setActualValue(value){
            if(!value) value = this.model
            let is_found = false

            this.options.forEach( (v,i) => {
                if(v.value == value) {
                    this.value = v
                    is_found = true
                    return
                }
            })

            if(!is_found && this.clear_if_not_found){
                this.value = null
            }
        }
    }
}
</script>